import { ParticipantRole } from '../../../utils/participantRole';

export enum IntegrationChannel {
  CATO = 'cato'
}

export enum LookupEntityFieldType {
  TELEPHONE = 'telephone',
  EMAIL = 'email',
  CUSTOMER_ID = 'customerId'
}

// Outgoing message types
export enum ThirdPartyWSMethod {
  SUBSCRIBE = 'SubscribeThirdParty',
  UNSUBSCRIBE = 'UnsubscribeThirdParty',
  NOTIFY_CONVERSATION_OPENED = 'NotifyConversationOpened',
  NOTIFY_CONVERSATION_CLOSED = 'NotifyConversationClosed',
  NOTIFY_THIRD_PARTY_FOCUSED = 'NotifyThirdPartyFocused',
  NOTIFY_CHAT_MESSAGE = 'NotifyChatMessage'
}

type ConversationOpenedPayload = {
  channelConversationId: string;
  channel: IntegrationChannel;
  visualIdentifier?: string;
  lookupCustomer?: {
    fieldType: LookupEntityFieldType;
    fieldValue: string;
  };
  routingGroup?: string;
  conversationSubsidiaryId?: number;
  intentInteractionId?: string;
};

type ConversationClosedPayload = {
  channel: IntegrationChannel;
};

// Why Cato told Cassie the conversation on screen closed, logged with the close (CSD-3538)
export type CloseReason = 'chat-ended' | 'call-ended' | 'email-ended' | 'unknown';

export type CloseContext = {
  reason: 'chat-ended' | 'call-ended';
  endedContactId: string;
};

// Extra fields logged with a send to Cassie, never sent to the hub
export type CassieSendLogContext = {
  channel?: 'email';
  closeReason?: CloseReason;
  endedContactId?: string;
  resent?: boolean;
};

export type ThirdPartyFocusedPayload = {
  thirdPartyName: string;
};

type SubscribePayload = {
  thirdPartyName: string;
};
type UnsubscribePayload = Record<string, never>;

export type NotifyConversationOpenedPayload = ConversationOpenedPayload;

export type NotifyConversationClosedPayload = ConversationClosedPayload;

type NotifyConversationFocusedPayload = ThirdPartyFocusedPayload;

export type NotifyChatMessagePayload = {
  channelConversationId: string;
  channel: IntegrationChannel;
  message: string;
  participantRole: ParticipantRole.AGENT | ParticipantRole.CUSTOMER | ParticipantRole.SYSTEM | undefined;
};

export type OutgoingThirdPartyConnectorEventPayloads = {
  SubscribeThirdParty: SubscribePayload;
  UnsubscribeThirdParty: UnsubscribePayload;
  NotifyConversationOpened: NotifyConversationOpenedPayload;
  NotifyConversationClosed: NotifyConversationClosedPayload;
  NotifyThirdPartyFocused: NotifyConversationFocusedPayload;
  NotifyChatMessage: NotifyChatMessagePayload;
};

export type OutgoingEventPromiseType = {
  SubscribeThirdParty: undefined;
  UnsubscribeThirdParty: undefined;
  NotifyConversationOpened: undefined;
  NotifyConversationClosed: undefined;
  NotifyThirdPartyFocused: undefined;
  NotifyChatMessage: undefined;
};
